import { render, staticRenderFns } from "./requests_and_payments.vue?vue&type=template&id=0a68088b&"
import script from "./requests_and_payments.vue?vue&type=script&lang=js&"
export * from "./requests_and_payments.vue?vue&type=script&lang=js&"
import style0 from "./requests_and_payments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports